/**
 * BatchExporterWrapper Component
 * Wrapper for Batch Track Exporter modal
 */

import React from 'react';
import BatchTrackExporter from '../tracks/BatchTrackExporter';

export const BatchExporterWrapper = ({
  isOpen,
  onClose,
  tracks,
  onImportTracks,
  projectName,
  audioContextRef,
}) => {
  return (
    <BatchTrackExporter
      isOpen={isOpen}
      onClose={onClose}
      tracks={tracks}
      onImportTracks={onImportTracks}
      projectName={projectName}
      audioContext={audioContextRef?.current}
    />
  );
};

export default BatchExporterWrapper;
